/**
 * Utilidades para la gestión y validación de entidades Cliente
 */

export const isActiveCliente = (cliente) => {
  return cliente && cliente.estado === 'Activo' && !cliente.deletedAt;
};

export const hasValidWhatsapp = (cliente) => {
  return !!cliente.whatsapp;
};

export const isReenviarCandidate = (cliente) => {
  return isActiveCliente(cliente) && hasValidWhatsapp(cliente);
};
